import React, { Component } from "react";
import _ from "lodash";
import { Row, Col, Form } from "reactstrap";
import { connect } from "react-redux";
// import actionFilter from "../../store/advancedfilter/action";
import actionFilter from "../../../store/advancedfilter/action";

class Teams extends Component {
  onChange(item) {
    var teamNamesIndex = _.findIndex(
      this.props.filterState.filterData.teams,
      (o) => {
        return o.id === item.id;
      }
    );
    item.checked = !this.props.filterState.filterData.teams[teamNamesIndex]
      .checked;
    this.props.filterState.filterData.teams[teamNamesIndex] = item;
    this.props.setFilterData({
      ...this.props.filterState.filterData,
    });
  }
  chechboxes(item, index) {
    return (
      <li
        class="list-group-item border-0"
        key={"teamitem-" + index}
        style={{
          backgroundColor: this.props.isMobile ? "transparent" : "white",
        }}
      >
        <span
          className="card-text custom-checkbox ml-4"
          key={"teitem-" + index}
        >
          <input
            type="checkbox"
            htmlFor={"teitem-" + index}
            value={item.id}
            checked={item.checked}
            className="custom-control-input"
            id={"teitem-" + index}
            name={"teitem-" + index}
            onChange={() => this.onChange(item)}
          />

          <label
            className="custom-control-label"
            htmlFor={"teitem-" + index}
            style={{ color: this.props.isMobile ? "white" : null }}
          >
            {item.teamName}
            <small className="totalCount">{`(${item.total})`}</small>
          </label>
        </span>
      </li>
    );
  }

  render() {
    return (
      <>
        {this.props.isMobile !== true ? (
          <>
            <h4>Teams</h4>
            <hr />
          </>
        ) : (
          ""
        )}
        <div className="filter-fields-scroll">
          <ul className="list-group">
            {this.props.filterState.filterData.teams &&
              !_.isEmpty(this.props.filterState.filterData) &&
              this.props.filterState.filterData.teams.map((item, index) =>
                this.chechboxes(item, index)
              )}
          </ul>
        </div>
        <div className="height-scroll"></div>
      </>
    );
  }
}

export default connect((state) => ({ filterState: state.advancedFilter }), {
  ...actionFilter,
})(Teams);
